import { render, staticRenderFns } from "./ADashBoard.vue?vue&type=template&id=2d8707a5&scoped=true"
import script from "./ADashBoard.vue?vue&type=script&lang=js"
export * from "./ADashBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8707a5",
  null
  
)

export default component.exports